import React from 'react'
import { Button } from '@mui/material';
import { Link } from 'react-router-dom'

function Main(props){
    console.log(props.test)
    return (
        <div id="default_message">
            <div id="Main">
                <div className="lead">左サイドバーよりカテゴリを選択してください</div>
                <Button variant="outlined"><Link to="/category">カテゴリを編集する</Link></Button>
            </div>
        </div>
    );
}

export default Main

